<template>
    <input data-slot="control" :type="type" v-model="modelValue" :aria-invalid="hasError" :aria-describedby="errorId" :class="size ? `form-input-${size}` : 'form-input-md'" />
</template>

<script setup>
const modelValue = defineModel({
    type: [String, Number],
    default: ''
})

defineProps({
    type: {
        type: String,
        default: 'text'
    },
    hasError: {
        type: Boolean,
        default: false
    },
    errorId: {
        type: String,
        default: null
    },
    size: {
        type: String,
        default: ''
    }
})
</script>
